import { gql } from '@apollo/client'
import { USER_DATA_FRAGMENT } from '../mutations'

// Verify 2FA code after sign-in
export const AUTH_VERIFY_TWO_FACTOR_MUTATION = gql`
  mutation AUTH_VERIFY_TWO_FACTOR_MUTATION($twoFactorToken: String!, $code: String!) {
    authVerifyTwoFactor(twoFactorToken: $twoFactorToken, code: $code) {
      ok
      data {
        accessToken
        user {
          ...USER_DATA
        }
      }
    }
  }
  ${USER_DATA_FRAGMENT}
`

// Initiate 2FA setup (authenticated)
export const AUTH_TWO_FACTOR_SETUP_MUTATION = gql`
  mutation AUTH_TWO_FACTOR_SETUP_MUTATION {
    authTwoFactorSetup {
      ok
      data {
        otpauthUri
        backupCodes
      }
    }
  }
`

// Confirm 2FA setup (authenticated)
export const AUTH_TWO_FACTOR_CONFIRM_SETUP_MUTATION = gql`
  mutation AUTH_TWO_FACTOR_CONFIRM_SETUP_MUTATION($code: String!) {
    authTwoFactorConfirmSetup(code: $code) {
      ok
      message
    }
  }
`

// Disable 2FA (authenticated)
export const AUTH_TWO_FACTOR_DISABLE_MUTATION = gql`
  mutation AUTH_TWO_FACTOR_DISABLE_MUTATION($code: String, $password: String) {
    authTwoFactorDisable(code: $code, password: $password) {
      ok
      message
    }
  }
`

// Regenerate backup codes (authenticated)
export const AUTH_TWO_FACTOR_REGENERATE_CODES_MUTATION = gql`
  mutation AUTH_TWO_FACTOR_REGENERATE_CODES_MUTATION($code: String!) {
    authTwoFactorRegenerateBackupCodes(code: $code) {
      ok
      data {
        otpauthUri
        backupCodes
      }
    }
  }
`

// Admin reset (authenticated, admin only)
export const AUTH_TWO_FACTOR_ADMIN_RESET_MUTATION = gql`
  mutation AUTH_TWO_FACTOR_ADMIN_RESET_MUTATION($userId: ID!, $companyId: ID) {
    authTwoFactorAdminReset(userId: $userId, companyId: $companyId) {
      ok
      message
    }
  }
`
